import { Checkbox, FormControl, FormControlLabel } from '@material-ui/core';
import { FormikProps } from 'formik';
import React from 'react';
import { v4 } from 'uuid';
import * as Yup from 'yup';

import { FormBodyAPI, SignatureComponentType } from 'src/constants';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { BaseTextField } from 'src/legacy/components/TextField';

interface FormValues {
  componentType: SignatureComponentType | null;
  label: string;
  isOptional: boolean;
}

const getSubmitValues = () => Promise.resolve({ key: v4() });

export const useClientInputLabelForm = ({
  componentType,
  isRequired,
}: {
  componentType: SignatureComponentType | null;
  isRequired: boolean;
}) => {
  let labelSchema: Yup.StringSchema<string> = Yup.string().trim();
  if (isRequired) {
    labelSchema = labelSchema.required('Label is required');
  }
  if (componentType === SignatureComponentType.REQUEST_TEXT) {
    labelSchema = labelSchema.max(4000, 'Maximum 4000 characters');
  }

  const validationScheme = Yup.object().shape({ label: labelSchema });

  const FormRenderer: React.FC<FormBodyAPI<FormValues>> = (props) => {
    // without typecasting we get an eslint error when trying to set field values
    const { touched, errors, values, setFieldValue, handleChange, handleBlur } =
      props as FormikProps<FormValues>;

    return (
      <div>
        <FormControl fullWidth>
          <BaseTypography fontType="13Medium">Label</BaseTypography>
          <BaseTextField
            name="label"
            onChange={handleChange}
            onBlur={handleBlur}
            helperText={touched && errors ? touched.label && errors.label : ''}
            variant="outlined"
            error={Boolean(touched.label && errors.label)}
            inputProps={{
              'data-testid': 'label-input',
              maxLength: 4001,
            }}
            autoFocus
          />
        </FormControl>
        {/* Optional checkbox for text signature inputs */}
        {values.componentType === SignatureComponentType.REQUEST_TEXT && (
          <div className="mt-4">
            <FormControlLabel
              control={
                <Checkbox
                  checked={values.isOptional}
                  name="isOptional"
                  onChange={() =>
                    setFieldValue('isOptional', !values.isOptional)
                  }
                  color="primary"
                  data-testid="isOptional-checkbox"
                />
              }
              label="Make field optional"
              id="make-field-optional-checkbox"
            />
          </div>
        )}
      </div>
    );
  };

  return { validationScheme, getSubmitValues, FormRenderer };
};
